

let numFilter = value => {
  // 截取当前数据到小数点后两位
  // value = fomatFloat(value)
  // let realVal = Number(value).toFixed(2)
  // // num.toFixed(2)获取的是字符串
  // return Number(realVal)

  if (isNaN(value)) {  
    return false;  
  }  
  let f = Math.round(value*100)/100;  
  let s = f.toString();  
  let rs = s.indexOf('.');  
  if (rs < 0) {  
    rs = s.length;  
    s += '.';  
  }  
  while (s.length <= rs + 2) {  
    s += '0';  
  }  
  return s; 
}
//提取汉字
let GetChinese = strValue=> {
  if(strValue!= null && strValue!= ""){
    var reg = /[\u4e00-\u9fa5]/g;
    return strValue.match(reg).join("");
  }
  else
    return "";
}
export { numFilter,GetChinese }



// WEBPACK FOOTER //
// ./src/static/js/filters.js